'use client';

import posthog from 'posthog-js';
import type { SegmentAnalytics } from '@posthog/types';
import { useEffect } from 'react';

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com';
let hasInitializedPosthog = false;

export default function useSegmentPosthogSync() {
  useEffect(() => {
    if (!posthogKey || hasInitializedPosthog) {
      return;
    }

    const initializeWithSegment = () => {
      const analytics = (window as any).analytics;

      if (!analytics?.ready || !analytics?.user) {
        return false;
      }

      hasInitializedPosthog = true;

      analytics.ready(() => {
        posthog.init(posthogKey, {
          api_host: posthogHost,
          capture_pageview: false, // We handle page views manually elsewhere
          capture_pageleave: true,
          disable_session_recording: false,
          enable_heatmaps: true,
          segment: window.analytics as unknown as SegmentAnalytics,
        });
      });

      return true;
    };

    if (initializeWithSegment()) {
      return;
    }

    const intervalId = window.setInterval(() => {
      if (initializeWithSegment()) {
        window.clearInterval(intervalId);
      }
    }, 250);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);
}
